/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable camelcase */
import React, { useState ,useEffect} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import moment from 'moment';
import { getBoxVoipmonActivity } from '../../../../actions/EpikBoxes';
import Spinner from '../../../Spinner/Spinner';
import './Cdr.css';
import { ReactComponent as AnalyticsIcon } from '../../../../Res/CDR/datagram_1.svg';

const callContextLookup = {
  public: 'inbound',
  default: 'outbound',
  enhancedroute: 'outbound',
  tdm: 'outbound' 
}

const Cdr = ({ cdr, index,onRowSelect}) => {
  const dispatch = useDispatch();
  const boxDetails = useSelector(state => state.AppState.boxDetails.box);
  const user = useSelector(state => state.AppState.user);
  const [isLoading, setIsLoading] = useState(false);
  const [selectRow, setSelectRow] = useState();

  const [activeTooltipLogsId, setActiveTooltipLogsId] = useState(null);


  const token = localStorage.getItem('jwtToken') || null;

  const {
    effective_caller_id_number,
    caller_id_number,
    destination_number,
    context,
    start_stamp,
    end_stamp,
    duration,
    rtp_audio_in_mos,
    sip_h_X_Epik_Call_Id,
    epik_cdr_callid
  } = cdr;

  let destinationNumber = destination_number;
  let callerNumber = effective_caller_id_number;
  if (context === 'public') {
    destinationNumber = destination_number === 'handleFailure' && sip_h_X_Epik_Call_Id ? sip_h_X_Epik_Call_Id : destination_number;
    callerNumber = caller_id_number;
  }

  // const changeGMT7 = date => {
  //   return new Date(
  //     date.getTime() - 7 * 60 * 60 * 1000, // Convert 7 hours to milliseconds
  //   );
  // };

  // Convert UTC time from box cdr to local time, and send the UTC to voipmon
  function dateString(date, type = 1){
    if(type === 1){
      return `${date.split(" ").join('T')}Z`
    }

    return `${date.split(" ").join('T')}`
  }
  

  // const currentDate = epik_cdr_callid 
  // ? moment.utc(dateString(start_stamp, 2)).subtract(1, 'minutes').format('YYYY-MM-DD') 
  // : moment.utc(dateString(start_stamp, 2)).subtract(1, 'minutes').format('YYYY-MM-DDTH:mm');
  const currentDate = epik_cdr_callid
  ? moment.utc(dateString(start_stamp, 2)).format('YYYY-MM-DD')
  : moment.utc(dateString(start_stamp, 2)).format('YYYY-MM-DDTH:mm');


  // const isoDateStringStartDisplay = moment(dateString(start_stamp))
  //   .local(true)
  //   .subtract(1, 'minutes')
  //   .format('YYYY-MM-DDTH:mm');

  const isoDateStringStartDisplay = moment.utc(dateString(start_stamp))
  .local()
  .format('YYYY-MM-DDTH:mm');


  // const endDate = epik_cdr_callid 
  // ? moment.utc(dateString(end_stamp, 2)).add(1, 'minutes').format('YYYY-MM-DD')
  // :moment.utc(dateString(end_stamp, 2)).add(1, 'minutes').format('YYYY-MM-DDTH:mm');;

  const endDate = epik_cdr_callid
  ? moment.utc(dateString(end_stamp, 2)).local().format('YYYY-MM-DD')
  : moment.utc(dateString(end_stamp, 2)).local().format('YYYY-MM-DDTH:mm');


  // const isoDateStringEnd = moment(dateString(end_stamp))
  //   .add(1, 'minutes')
  //   .format('YYYY-MM-DDTH:mm:ss');
  const isoDateStringEnd = moment.utc(dateString(end_stamp))
  .local()
  .format('YYYY-MM-DDTH:mm:ss');
  

    const onRowSelected = async e => {
      setSelectRow(e)
      onRowSelect(e);
    }
  const onRowClick = async (e,rowData) => {
    onRowSelect(rowData);
    setIsLoading(true);
    const { calldatefrom, calldateto, callerid, calledid, type ,fcallid} = e.currentTarget.dataset;
    const { _id, advancedRouting } = boxDetails;

    console.log({ type, advancedRouting });

    const callerName = type === 'outbound' && advancedRouting;

    const payload = {
      callDateFrom: calldatefrom || '',
      callDateTo: calldateto || '',
      callerID: !callerName ? callerid : '',
      calledID: calledid || '',
      callerName: callerName ? callerid : '',
      fcallid:fcallid ? fcallid : '',
      datacenter: rowData?.datacenter ? rowData?.datacenter : ''
    };
    await dispatch(getBoxVoipmonActivity(token, _id, payload));
    setIsLoading(false);
  };

  const strPadLeft = (string, pad, length) => {
    return (new Array(length + 1).join(pad) + string).slice(-length);
  };

  const time = duration;
  const minutes = Math.floor(time / 60);
  const seconds = time - minutes * 60;

  const callDuration = `${strPadLeft(minutes, '0', 2)}:${strPadLeft(seconds, '0', 2)}`;

  const permissions = user?.role !== 'user' && user?.role !== 'admin';

  const handleMouseEnter = (id, type) => {
    if (type === 'cdr-logs') {
      setActiveTooltipLogsId(id);
    } 
  };

  const handleMouseLeave = (type) => {
    if (type === 'cdr-logs') {
      setActiveTooltipLogsId(null);
    }
  };

  const callContext = context.toLowerCase();
  const hasVoipMonLog = effective_caller_id_number || caller_id_number  || destinationNumber;

  return (
    <>
      <tr>
        {/* <td>1</td> */}
        <td>{callerNumber || '-'}</td>
        <td>{destinationNumber || '-'}</td>
        <td>{context && callContextLookup[callContext] || ''}</td>
        <td>{isoDateStringStartDisplay.split('T')[0]}</td>
        <td>{isoDateStringStartDisplay.split('T')[1]}</td>
        <td>{callDuration}</td>
        <td>{rtp_audio_in_mos || '-'}</td>
        {permissions && hasVoipMonLog && (
          <td className='d-flex'>
            {isLoading ? (
              <Spinner />
            ) : (
              <AnalyticsIcon
                width={20}
                height={20}
                // onClick={onRowClick}
                onClick={(e) => onRowClick(e, cdr)}
                data-calldatefrom={currentDate}
                data-calldateto={endDate}
                data-callerid={effective_caller_id_number || caller_id_number || ''}
                data-fcallid={epik_cdr_callid ? epik_cdr_callid : '' }
                data-calledid={destinationNumber === 'handleFailure' ? '' : destinationNumber}
                data-type={context && callContextLookup[callContext] || ''}
                className='cursor-pointer analytics-icon mr-2'
                id={`cdr-logs-${index}`}
                onMouseEnter={() => handleMouseEnter(index, 'cdr-logs')}
                onMouseLeave={() => handleMouseLeave('cdr-logs')}
              />
            )}
          </td>
        )}
      </tr>
    </>
  );
};

export default Cdr;
